module.exports = __webpack_public_path__ + "img/USDT.dc0233d7.svg";